import { EAppId } from "@timeedit/types/lib/enums";
import { purple6, yellow6, cyan6, red6, blue6, green6 } from "./tokens";
export * from "./tokens";
//-----------------------------------------------------------------------------
// --> Product Colors
//-----------------------------------------------------------------------------
export const productColors = {
    [EAppId.TE_ADMIN]: "#333333",
    [EAppId.TE_ALLOCATE]: purple6,
    [EAppId.TE_CORE]: purple6,
    [EAppId.TE_CURRICULUM]: yellow6,
    [EAppId.TE_DATA_MANAGER]: purple6,
    [EAppId.TE_EVALUATION]: cyan6,
    [EAppId.TE_EXAM]: purple6,
    [EAppId.TE_EXAM_V3]: purple6,
    [EAppId.TE_PLAN]: red6,
    [EAppId.TE_PREFERENCES]: purple6,
    [EAppId.TE_REGISTRATION]: blue6,
    [EAppId.TE_REPORTING]: cyan6,
    [EAppId.TE_RESERVE]: purple6,
    [EAppId.TE_STUDY_GUIDE]: blue6,
    [EAppId.TE_STUDY_PLANNER]: blue6,
    [EAppId.TE_VIEWER]: blue6,
    [EAppId.TE_HUB]: green6,
    // not known
    [EAppId.TE_AUTOPILOT]: green6,
    [EAppId.TE_PORTAL]: green6
};
